<div cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container" [cdkDragDisabled]="disableDrag">
  @if (title) {
    <div [class]="disableDrag ? 'tw-pb-1 ' + (customHeaderClass || '') : 'cursor-grab tw-pb-1 ' + (customHeaderClass || '')" cdkDragHandle>
      <div class="tw-flex tw-justify-between tw-items-center">
        <div class="tw-flex tw-items-center">
          @if (!disableDrag) {
            <calio-mat-icon iconType="drag_indicator" height="23px" width="23px" fill="hsl(var(--muted-foreground))" />
          }
          <div class="title">
            {{ title | translate }}
          </div>
        </div>
        <div class="tw-flex tw-items-center">
          @if (headerAction) {
            <a class="header-action-link tw-mr-3" (click)="headerAction.callback()">
              {{ headerAction.labelKey | translate }}
            </a>
          }
          @if (showDialogCloseButton) {
            <button type="button" class="tw-btn-close" aria-label="Close" (keydown.enter)="$event.preventDefault()" (click)="close()">
            </button>
          }
        </div>
      </div>
      <div class="subtitle">
        {{ subtitle | translate: subtitleTranslationJson }}
      </div>
    </div>
    <hr class="separator"/>
  } @else {
    <span class="tw-hidden" cdkDragHandle></span>
  }
  <ng-template appDynamicDirective />
</div>

